import React from "react";
import styled, { keyframes } from "styled-components";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import SubVisual from "../Public/SubVisual";
import { CONTACT_DATA } from "../../../Models/ArrowData";

const reveal = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Contact = () => {
  return (
    <>
      <Header />
      <SubVisual title="부문별 담당" subTitle="고객지원" />

      <PageContainer>
        <InnerWrapper>
          <IntroSection>
            <div className="label-group">
              <h5 className="sub">CONTACT CHANNEL</h5>
            </div>
            {/* <h2 className="main">부문별 담당</h2> */}
          </IntroSection>

          <ContactGrid>
            {CONTACT_DATA.map((dept, idx) => (
              <ContactCard key={dept.category} delay={idx * 0.1}>
                <div className="card-header">
                  <span className="category-label">{dept.category}</span>
                  <h3 className="dept-title">{dept.title}</h3>
                </div>

                <div className="card-body">
                  {dept.items.map((item, i) => (
                    <ContactItem key={i}>
                      <p className="area-name">{item.area}</p>
                      <div className="info-row">
                        <div className="info-box">
                          <span className="info-label">TEL</span>
                          <span className="info-val">{item.tel}</span>
                        </div>
                        <div className="info-box">
                          <span className="info-label">E-MAIL</span>
                          <span className="info-val">{item.email}</span>
                        </div>
                      </div>
                    </ContactItem>
                  ))}
                </div>
              </ContactCard>
            ))}
          </ContactGrid>

          {/* <BottomNotice>
            <p>
              ※ 평일 오전 9시 ~ 오후 6시 (토, 일 및 공휴일 제외) 상담이
              가능합니다.
            </p>
            <p>
              ※ 긴급 장애 발생 시 각 부문별 기술 담당자에게 직접 연락 주시기
              바랍니다.
            </p>
          </BottomNotice> */}
        </InnerWrapper>
      </PageContainer>

      <Footer />
    </>
  );
};

export default Contact;

// --- 스타일 컴포넌트 ---

const PageContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding-bottom: 150px;

  @media (max-width: 768px) {
    padding-bottom: 80px; /* 모바일: 하단 여백 축소 */
  }
`;

const InnerWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
`;

const IntroSection = styled.div`
  padding: 120px 0 40px 0;
  animation: ${reveal} 1s ease-out forwards;

  .label-group {
    display: flex;
    align-items: center;
    gap: 5px;
    .accent-dot {
      width: 6px;
      height: 6px;
      background-color: #00d2ff;
      border-radius: 50%;
    }
    .sub {
      font-size: 0.9rem;
      font-weight: 700;
      /* color: #00d2ff; */
      color: gray;
      letter-spacing: 1px;
    }
  }

  .main {
    font-size: 3.2rem;
    font-weight: 800;
    line-height: 1.3;
    color: #1a1a1a;
    letter-spacing: -1px;
  }

  @media (max-width: 768px) {
    padding: 60px 0 40px 0; /* 모바일: 상하 패딩 축소 */

    .main {
      font-size: 2.2rem; /* 모바일: 제목 폰트 크기 조절 */
      word-break: keep-all;
      br {
        display: none; /* 자연스러운 줄바꿈 유도 */
      }
    }
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  animation: ${reveal} 1s ease-out 0.3s forwards;
  opacity: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px; /* 모바일/태블릿: 카드 간격 축소 */
  }
`;

const ContactCard = styled.div`
  border: 1px solid #eee;
  padding: 50px;
  background-color: #fff;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: #00d2ff;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
    transform: translateY(-5px);
  }

  .card-header {
    margin-bottom: 40px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 25px;

    .category-label {
      font-size: 0.8rem;
      font-weight: 800;
      color: #bbb;
      letter-spacing: 2px;
      display: block;
      margin-bottom: 12px;
    }

    .dept-title {
      font-size: 2rem;
      font-weight: 800;
      color: #1a1a1a;
    }
  }

  @media (max-width: 768px) {
    padding: 30px; /* 모바일: 카드 내부 여백 대폭 축소 */

    &:hover {
      transform: none; /* 모바일에서는 호버 애니메이션 비활성화 (터치 환경 고려) */
    }

    .card-header {
      margin-bottom: 25px;
      padding-bottom: 20px;

      .dept-title {
        font-size: 1.4rem; /* 부서명 폰트 축소 */
      }
    }
  }
`;

const ContactItem = styled.div`
  margin-bottom: 35px;
  &:last-child {
    margin-bottom: 0;
  }

  .area-name {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 15px;
  }

  .info-row {
    display: flex;
    gap: 80px;
    padding-left: 10px;

    .info-box {
      min-width: 120px;
      .info-label {
        display: none;
        font-size: 1rem;
        font-weight: 800;
        /* color: #00d2ff; */
        color: gray;
        margin-bottom: 5px;
        letter-spacing: 1px;
      }
      .info-val {
        font-size: 1.1rem;
        font-weight: 500;
        color: #555;
      }
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 25px;

    .area-name {
      font-size: 1.05rem;
      margin-bottom: 12px;
    }

    .info-row {
      flex-direction: column; /* 모바일: 가로 배열을 세로 배열로 변경 */
      gap: 15px; /* 간격 축소 */

      .info-box {
        .info-val {
          font-size: 1rem;
          word-break: break-all; /* 긴 이메일 주소 줄바꿈 처리 */
        }
      }
    }
  }
`;

const BottomNotice = styled.div`
  margin-top: 80px;
  padding: 30px;
  background-color: #f8f9fa;
  border-radius: 4px;

  p {
    font-size: 0.95rem;
    color: #888;
    line-height: 1.8;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    margin-top: 40px; /* 상단 간격 축소 */
    padding: 20px; /* 내부 여백 축소 */

    p {
      font-size: 0.85rem; /* 폰트 크기 조절 */
      line-height: 1.6;
      word-break: keep-all; /* 단어 단위 줄바꿈 유지 */
      margin-bottom: 8px; /* 문단 간격 조절 */

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
